"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = ({ selected }) => {
    const theme = (0, material_1.useTheme)();
    const tipContainer = Object.assign({ display: 'flex', alignItems: 'center', justifyContent: 'center', borderTop: `1px solid ${theme.palette.grey[300]}`, width: '100%', backgroundColor: 'rgba(255, 255, 255, 1)', borderRadius: '0 0 6px 6px', whiteSpace: 'normal' }, (selected && {
        borderTop: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.primary.main,
    }));
    const tipDescriptions = {
        width: '74px',
        lineHeight: '0.6',
        textAlign: 'center',
        paddingTop: '3px',
        paddingBottom: '7px',
    };
    const descriptions = Object.assign({ fontSize: '9px', color: theme.qlub.palette.black.main, textAlign: 'center', lineHeight: '0.6', wordBreak: 'break-word' }, (selected && {
        color: theme.palette.primary.contrastText,
    }));
    const tipIcon = {
        width: '62px',
        textAlign: 'center',
        paddingTop: '3px',
        paddingBottom: '1px',
    };
    return {
        descriptions,
        tipContainer,
        tipDescriptions,
        tipIcon,
    };
};
exports.default = useStyle;
